import React, { useState, useEffect, useRef } from 'react';
import { FiFilter, FiRotateCw, FiChevronDown } from "react-icons/fi";
import { DayPicker } from "react-day-picker";
import "react-day-picker/dist/style.css";
import { format, isSameDay } from "date-fns";
import check from "../../assets/check.svg";
import { useNavigate } from 'react-router-dom';
import { getAllShipmentForPOD, getShipmentByIdPod } from '../../ApiController/ApiService';
import JSZip from 'jszip';
import { saveAs } from 'file-saver';
import { useTranslation } from 'react-i18next';

// 1. Import Context
import { useDashboard } from '../Context/Dashboardcontext';

const statusColors = {
    Uploaded: '✅',
    Failed: '❌',
    Incomplete: '⚠️',
    Pending: '⏳',
};

const drivers = [
    { id: 1, name: 'John Doe', avatar: 'https://i.pravatar.cc/40?img=1' },
    { id: 2, name: 'Jane Smith', avatar: 'https://i.pravatar.cc/40?img=2' },
    { id: 3, name: 'Alex Johnson', avatar: 'https://i.pravatar.cc/40?img=3' },
];

const ProofOfDelivery = () => {
    const { t } = useTranslation(); // Initialize translation hook
    
    // 2. Get userProfile from Context
    const { userProfile } = useDashboard();

    const [showCalendar, setShowCalendar] = useState(false);
    const [calendarPosition, setCalendarPosition] = useState({ top: 0, left: 0 });
    const [selectedDates, setSelectedDates] = useState([]);
    const [showDropdown, setShowDropdown] = useState(false);
    const [showDropdown2, setShowDropdown2] = useState(false);
    const [selectedRegions, setSelectedRegions] = useState([]);
    const [selectedStatuses, setSelectedStatuses] = useState([]);
    const dropdownRef = useRef(null);
    const dropdownRef2 = useRef(null);
    const calendarRef = useRef(null);
    const buttonRef = useRef(null);
    const buttonRef2 = useRef(null);
    const buttonRef3 = useRef(null);
    const [isSuccessModalOpen, setIsSuccessModalOpen] = useState(false);
    const navigate = useNavigate();
    const [showModal2, setShowModal2] = useState(false);
    const [showRequestModal, setRequestModal] = useState(false);
    const [search, setSearch] = useState('');
    const [selectedDriver, setSelectedDriver] = useState(null);
    const [isOpen, setIsOpen] = useState(false);
    const [selected, setSelected] = useState("");
    const [customReason, setCustomReason] = useState("");
    const [shipments, setShipments] = useState([]);
    const [filteredShipments, setFilteredShipments] = useState([]);
    const [selectedShipment, setSelectedShipment] = useState(null);
    const [loading, setLoading] = useState(false);
    const [viewLoadingId, setViewLoadingId] = useState(null);
    const [error, setError] = useState('');

    const isValidDate = (date) => date && !isNaN(new Date(date).getTime());

    const filteredDrivers = drivers.filter(driver =>
        driver.name.toLowerCase().includes(search.toLowerCase())
    );

    const regions = ["tx", "ca", "la"];
    const statuses = ["Completed", "In-transit", "Delayed", "Pending", "PODSubmitted", "Returned"];

    useEffect(() => {
        const fetchShipments = async () => {
            try {
                setLoading(true);
                const status = selectedStatuses.length > 0 ? selectedStatuses.join(',') : '';
                const location = selectedRegions.length > 0 ? selectedRegions.join(',') : '';
                const fromDate = selectedDates.length > 0 ? format(selectedDates[0], 'yyyy-MM-dd') : '';

                const response = await getAllShipmentForPOD({
                    status,
                    page: 1,
                    limit: 10,
                    origin: location,
                    // portName: location,
                    pickUpDate: fromDate,
                });

                console.log('API Response:', response);

                const fetchedShipments = response.data?.docs || [];

                // 3. Apply Dispax vs AI Package logic
                let allowedShipments = fetchedShipments;
                if (userProfile && !userProfile.aiPackageId) {
                    // If NO AI package, originally only showed Dispax.
                    // Relaxing for Loads (no companyType) and SemiSolution testing.
                    allowedShipments = fetchedShipments.filter(shipment => 
                        !shipment.companyType || 
                        shipment.companyType === 'Dispax' || 
                        shipment.companyType === 'SemiSolution'
                    );
                }

                setShipments(allowedShipments);

                // 4. Apply UI filters (status, regions, dates) on top of allowedShipments
                const filtered = allowedShipments.filter(shipment => {
                    const matchesStatus = selectedStatuses.length === 0 || selectedStatuses.includes(shipment.status);
                    const matchesLocation = selectedRegions.length === 0 ||
                        selectedRegions.includes(shipment.origin) ||
                        selectedRegions.includes(shipment.pickupAddress) ||
                        selectedRegions.includes(shipment.destination) ||
                        selectedRegions.includes(shipment.deliveryAddress) ||
                        selectedRegions.includes(shipment.portName);
                    const matchesDate = selectedDates.length === 0 ||
                        selectedDates.some(date =>
                            (shipment.pickUpDate && isValidDate(shipment.pickUpDate) && isSameDay(new Date(shipment.pickUpDate), date)) ||
                            (shipment.dropOffDate && isValidDate(shipment.dropOffDate) && isSameDay(new Date(shipment.dropOffDate), date)) ||
                            (shipment.podDate && isValidDate(shipment.podDate) && isSameDay(new Date(shipment.podDate), date))
                        );
                    return matchesStatus && matchesLocation && matchesDate;
                });

                setFilteredShipments(filtered);
            } catch (err) {
                console.error('Fetch Error:', err);
                setError(t('errors.fetchShipmentsFailed')); 
            } finally {
                setLoading(false);
            }
        };

        // Only fetch when userProfile is available so it doesn't default incorrectly
        if (userProfile !== undefined) {
            fetchShipments();
        }

    // 5. Added userProfile to dependency array
    }, [selectedRegions, selectedStatuses, selectedDates, t, userProfile]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                calendarRef.current &&
                !calendarRef.current.contains(event.target) &&
                buttonRef.current &&
                !buttonRef.current.contains(event.target)
            ) {
                setShowCalendar(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (
                dropdownRef.current &&
                !dropdownRef.current.contains(e.target) &&
                buttonRef2.current &&
                !buttonRef2.current.contains(e.target)
            ) {
                setShowDropdown(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (
                dropdownRef2.current &&
                !dropdownRef2.current.contains(e.target) &&
                buttonRef3.current &&
                !buttonRef3.current.contains(e.target)
            ) {
                setShowDropdown2(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const handleCalendarToggle = () => {
        if (buttonRef.current) {
            const rect = buttonRef.current.getBoundingClientRect();
            setCalendarPosition({
                top: rect.bottom + window.scrollY,
                left: rect.left + window.scrollX,
            });
        }
        setShowCalendar((prev) => !prev);
    };

    const toggleRegion = (region) => {
        setSelectedRegions(prev =>
            prev.includes(region)
                ? prev.filter(r => r !== region)
                : [...prev, region]
        );
    };

    const toggleStatus = (status) => {
        setSelectedStatuses(prev =>
            prev.includes(status)
                ? prev.filter(s => s !== status)
                : [...prev, status]
        );
    };

    const openRequestModal = () => {
        setShowModal2(false);
        setRequestModal(true);
    };

    const openSuccessModal = async () => {
        if (!selectedShipment) return;

        setShowModal2(false);
        setLoading(true);

        try {
            const zip = new JSZip();

            const reportData = {
                containerNumber: selectedShipment.containerNumber || t('dashboard.na'),
                orderId: selectedShipment.orderId || t('dashboard.na'),
                driverContactNumber: selectedShipment.driverContactNumber || t('dashboard.na'),
                vehicleNumber: selectedShipment.vehicleNumber || t('dashboard.na'),
                route: `${selectedShipment.origin || t('dashboard.na')} → ${selectedShipment.destination || t('dashboard.na')}`,
                status: selectedShipment.status || t('dashboard.na'),
                description: selectedShipment.description || t('dashboard.na'),
                goodsType: selectedShipment.goodsType || t('dashboard.na'),
                containerType: selectedShipment.containerType || t('dashboard.na'),
                containerComments: selectedShipment.containerComments || t('dashboard.na'),
                noOfPallets: selectedShipment.noOfPallets || 0,
                weightInTons: selectedShipment.weightInTons || 0,
                pickUpDate: selectedShipment.pickUpDate && isValidDate(selectedShipment.pickUpDate)
                    ? `${format(new Date(selectedShipment.pickUpDate), 'PP')} ${selectedShipment.pickUpHours || '00'}:00`
                    : t('dashboard.na'),
                dropOffDate: selectedShipment.dropOffDate && isValidDate(selectedShipment.dropOffDate)
                    ? `${format(new Date(selectedShipment.dropOffDate), 'PP')} ${selectedShipment.dropOffHours || '00'}:00`
                    : t('dashboard.na'),
                portName: selectedShipment.portName || t('dashboard.na'),
                ticketNumber: selectedShipment.ticketNumber || t('dashboard.na'),
                bookingNumber: selectedShipment.bookingNumber || t('dashboard.na'),
                terminal: selectedShipment.terminal || t('dashboard.na'),
                routeNotes: selectedShipment.routeNotes || t('dashboard.na'),
                intermediateDestinations: selectedShipment.intermediateDestinations?.length > 0
                    ? selectedShipment.intermediateDestinations
                        .filter(dest => dest.time && isValidDate(dest.time))
                        .map(dest => `${dest.destination || t('dashboard.na')} (${format(new Date(dest.time), 'PP')})`)
                        .join(', ') || t('dashboard.na')
                    : t('dashboard.na'),
                paymentStatus: selectedShipment.paymentStatus || t('dashboard.na'),
            };
            zip.file('report.json', JSON.stringify(reportData, null, 2));

            const imageFields = [
                { name: 'container_image', urls: selectedShipment.podContainerImage || [] },
                { name: 'cargo_image', urls: selectedShipment.podCargo || [] },
                { name: 'delivery_site_image', urls: selectedShipment.podDeliverySite || [] },
                { name: 'pod_document', urls: selectedShipment.podDocuments || [] },
            ];

            for (const field of imageFields) {
                for (let i = 0; i < field.urls.length; i++) {
                    try {
                        const response = await fetch(field.urls[i]);
                        if (!response.ok) throw new Error(t('errors.fetchImageFailed', { name: field.name }));
                        const blob = await response.blob();
                        const extension = field.urls[i].split('.').pop().split('?')[0] || 'jpg';
                        zip.file(`${field.name}_${i + 1}.${extension}`, blob);
                    } catch (err) {
                        console.error(`Error fetching ${field.name}_${i + 1}:`, err.message);
                    }
                }
            }

            const content = await zip.generateAsync({ type: 'blob' });
            saveAs(content, `shipment_${selectedShipment.containerNumber || 'unknown'}.zip`);

            setIsSuccessModalOpen(true);
        } catch (err) {
            setError(t('errors.downloadReportFailed', { message: err.message }));
        } finally {
            setLoading(false);
        }
    };

    const handleSelect = (value) => {
        setSelected(value);
        if (value !== "Other") setCustomReason("");
        setIsOpen(false);
    };

    const handleViewShipment = async (shipment) => {
        try {
            setViewLoadingId(shipment._id);
            const response = await getShipmentByIdPod(shipment._id);
            // If API returns data, use it, otherwise fall back to shipment from state
            setSelectedShipment(response || shipment);
            setShowModal2(true);
        } catch (err) {
            console.warn('getShipmentByIdPod failed, falling back to row shipment data:', err);
            // Fallback to the already available shipment data from state so modal opens seamlessly
            setSelectedShipment(shipment);
            setShowModal2(true);
        } finally {
            setViewLoadingId(null);
        }
    };

    return (
        <div className="text-white relative p-4 sm:p-6">
            <div className="flex items-center justify-between mb-6">
                <h1 className="text-xl sm:text-2xl font-semibold">{t('pod.pod')}</h1>
            </div>

            <div className="flex items-center justify-between mb-6 flex-col sm:flex-row gap-4">
                <div className="flex flex-col sm:flex-row items-center bg-[#10194E] rounded-xl shadow-md w-full">
                    <div className="flex items-center gap-2 px-3 sm:px-4 py-4 sm:py-5 border-b sm:border-b-0 sm:border-r border-[#1E2A60] text-white w-full sm:w-auto">
                        <FiFilter className="text-lg" />
                        <span className="text-sm">{t('orders.filterBy')}</span>
                    </div>

                    <div className="relative w-full sm:w-auto">
                        <button
                            ref={buttonRef}
                            onClick={handleCalendarToggle}
                            className="px-3 sm:px-4 py-4 sm:py-5 text-sm text-white border-b sm:border-b-0 sm:border-r border-[#1E2A60] bg-transparent w-full sm:w-auto text-left sm:text-center"
                        >
                            {selectedDates.length > 0
                                ? selectedDates.map((date) => format(date, "PP")).join(", ")
                                : t('orders.date')}
                        </button>
                        {showCalendar && (
                            <div
                                ref={calendarRef}
                                className="absolute left-0 sm:left-9 sm:-translate-x-24 p-4 shadow-lg rounded z-50 w-[90%] sm:w-auto"
                                style={{
                                    background: 'radial-gradient(50% 49.39% at 50% 50%, #1D2461 0%, #080625 100%)',
                                }}
                            >
                                <DayPicker
                                    mode="multiple"
                                    selected={selectedDates}
                                    onSelect={setSelectedDates}
                                    footer={
                                        <div className="pt-4">
                                            <div className="flex justify-start">
                                                <span className="text-xs sm:text-sm text-gray-400">{t('orders.multipleDates')}</span>
                                            </div>
                                            <div className="flex justify-center mt-2">
                                                <button
                                                    onClick={() => setShowCalendar(false)}
                                                    className="bg-[#6F1AFF] text-white px-4 py-1 rounded text-sm"
                                                >
                                                    {t('orders.apply')}
                                                </button>
                                            </div>
                                        </div>
                                    }
                                />
                            </div>
                        )}
                    </div>

                    <div className="relative w-full sm:w-auto">
                        <button
                            ref={buttonRef2}
                            onClick={() => setShowDropdown(!showDropdown)}
                            className="bg-transparent text-white px-3 sm:px-4 py-4 sm:py-5 text-sm border-b sm:border-b-0 sm:border-r border-[#1E2A60] outline-none w-full sm:w-auto text-left sm:text-center"
                        >
                            {selectedRegions.length > 0 ? selectedRegions.join(', ') : t('orders.location')}
                        </button>
                        {showDropdown && (
                            <div
                                ref={dropdownRef}
                                className="absolute left-0 sm:right-0 top-full mt-2 w-[90%] sm:w-80 text-white rounded-2xl p-4 sm:p-6 z-10 shadow-lg"
                                style={{
                                    background: 'radial-gradient(50% 49.39% at 50% 50%, #1D2461 0%, #080625 100%)',
                                }}
                            >
                                <h2 className="text-base sm:text-lg font-semibold mb-4">{t('orders.location')}</h2>
                                <div className="grid grid-cols-2 sm:grid-cols-3 gap-2 sm:gap-3 mb-4">
                                    {regions.map((region) => (
                                        <button
                                            key={region}
                                            onClick={() => toggleRegion(region)}
                                            className={`px-2 sm:px-3 py-1 sm:py-2 rounded-full border transition-all text-xs sm:text-sm ${selectedRegions.includes(region)
                                                ? "bg-white text-black font-semibold"
                                                : "bg-[#1D2A85] hover:bg-[#2A3AA5]"
                                                }`}
                                        >
                                            {region}
                                        </button>
                                    ))}
                                </div>
                                <p className="text-xs sm:text-sm text-gray-300 mb-3">{t('orders.multipleLocations')}</p>
                                <div className="text-center">
                                    <button
                                        onClick={() => setShowDropdown(false)}
                                        className="bg-gradient-to-r from-[#6E00FF] to-[#A627FF] px-4 sm:px-6 py-2 rounded-lg text-white font-semibold hover:opacity-90 text-sm"
                                    >
                                        {t('orders.applyNow')}
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>

                    <div className="relative w-full sm:w-auto">
                        <button
                            ref={buttonRef3}
                            onClick={() => setShowDropdown2(!showDropdown2)}
                            className="bg-transparent text-white px-3 sm:px-4 py-4 sm:py-5 text-sm border-b sm:border-b-0 sm:border-r border-[#1E2A60] outline-none w-full sm:w-auto text-left sm:text-center"
                        >
                            {selectedStatuses.length > 0 ? selectedStatuses.join(', ') : t('orders.statusLabel')}
                        </button>
                        {showDropdown2 && (
                            <div
                                ref={dropdownRef2}
                                className="absolute left-0 sm:right-0 top-full mt-2 w-[90%] sm:w-80 text-white rounded-2xl p-4 sm:p-6 z-10 shadow-lg"
                                style={{
                                    background: 'radial-gradient(50% 49.39% at 50% 50%, #1D2461 0%, #080625 100%)',
                                }}
                            >
                                <h2 className="text-base sm:text-lg font-semibold mb-4">{t('orders.selectOrderStatus')}</h2>
                                <div className="grid grid-cols-2 sm:grid-cols-3 gap-2 sm:gap-3 mb-4">
                                    {statuses.map((status) => (
                                        <button
                                            key={status}
                                            onClick={() => toggleStatus(status)}
                                            className={`px-2 sm:px-3 py-1 sm:py-2 rounded-full border transition-all text-xs sm:text-sm ${selectedStatuses.includes(status)
                                                ? "bg-white text-black font-semibold"
                                                : "bg-[#1D2A85] hover:bg-[#2A3AA5]"
                                                }`}
                                        >
                                            {t(`orders.status.${status.toLowerCase()}`, { defaultValue: status })}
                                        </button>
                                    ))}
                                </div>
                                <p className="text-xs sm:text-sm text-gray-300 mb-3">{t('orders.multipleOrderStatus')}</p>
                                <div className="text-center">
                                    <button
                                        onClick={() => setShowDropdown2(false)}
                                        className="bg-gradient-to-r from-[#6E00FF] to-[#A627FF] px-4 sm:px-6 py-2 rounded-lg text-white font-semibold hover:opacity-90 text-sm"
                                    >
                                        {t('orders.applyNow')}
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>

                    <button
                        onClick={() => {
                            setSelectedDates([]);
                            setSelectedRegions([]);
                            setSelectedStatuses([]);
                        }}
                        className="flex items-center gap-1 px-3 sm:px-4 py-4 sm:py-5 text-sm text-orange-400 hover:underline w-full sm:w-auto text-left sm:text-center"
                    >
                        <FiRotateCw className="text-sm" />
                        {t('orders.resetFilter')}
                    </button>
                </div>
            </div>

            <div className="overflow-x-auto bg-[#1D2461] rounded-lg">
                {loading && <p className="text-center p-4">{t('dashboard.loading')}</p>}
                {!loading && filteredShipments.length === 0 && <p className="text-center p-4">{t('orders.noShipmentsFound')}</p>}
                {!loading && filteredShipments.length > 0 && (
                    <table className="min-w-full table-auto text-sm sm:text-base text-left">
                        <thead className="bg-[#B2BAFF] text-[#202224] font-nunito uppercase text-xs sm:text-[14px]">
                            <tr>
                                <th className="p-2 sm:p-4 w-12"><input type="checkbox" aria-label={t('alt.selectAll')} /></th>
                                <th className="p-2 sm:p-4 min-w-[100px]">{t('orders.containerId')}</th>
                                <th className="p-2 sm:p-4 min-w-[120px]">{t('dashboard.driver')}</th>
                                <th className="p-2 sm:p-4 min-w-[120px]">{t('orders.destination')}</th>
                                <th className="p-2 sm:p-4 min-w-[80px]">{t('pod.podStatus')}</th>
                                <th className="p-2 sm:p-4 min-w-[80px]">{t('orders.statusLabel')}</th>
                                <th className="p-2 sm:p-4 min-w-[80px]">{t('orders.actions')}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filteredShipments.map((shipment) => (
                                <tr key={shipment._id} className="border-t border-[#2A2A4D]">
                                    <td className="p-2 sm:p-4"><input type="checkbox" aria-label={t('alt.viewShipment', { id: shipment.containerNumber || 'unknown' })} /></td>
                                    <td className="p-2 sm:p-4">{shipment.containerNumber || shipment.Id || shipment._id?.slice(-6).toUpperCase() || t('dashboard.na')}</td>
                                    <td className="p-2 sm:p-4">{shipment.assignedDriverId?.fullName || shipment.acceptedId?.fullName || shipment.userId?.fullName || t('dashboard.na')}</td>
                                    <td className="p-2 sm:p-4 truncate max-w-[150px]">{shipment.destination || shipment.deliveryAddress || t('dashboard.na')}</td>
                                    <td className="p-2 sm:p-4">
                                        {statusColors[
                                            shipment._podSource === 'Load'
                                                ? (shipment.podImage || shipment.recipientSignature ? 'Uploaded' : 'Pending')
                                                : (shipment.podTermsAccepted ? 'Uploaded' : shipment.podDocuments?.length > 0 ? 'Incomplete' : 'Pending')
                                        ] || '⏳'}
                                    </td>
                                    <td className="p-2 sm:p-4">{t(`orders.status.${(shipment.status || '').toLowerCase()}`, { defaultValue: shipment.status || t('dashboard.na') })}</td>
                                    <td className="p-2 sm:p-4">
                                        <button
                                            onClick={() => handleViewShipment(shipment)}
                                            disabled={viewLoadingId === shipment._id}
                                            className="bg-[#00B69B] text-white px-3 sm:px-4 py-1 sm:py-1 rounded-2xl hover:bg-blue-600 text-xs sm:text-sm flex items-center justify-center gap-1.5 disabled:opacity-60 disabled:cursor-not-allowed min-w-[65px]"
                                            aria-label={t('alt.viewShipment', { id: shipment.containerNumber || 'unknown' })}
                                        >
                                            {viewLoadingId === shipment._id ? (
                                                <>
                                                    <span className="w-3 h-3 border-2 border-white border-t-transparent rounded-full animate-spin"></span>
                                                    <span>...</span>
                                                </>
                                            ) : (
                                                t('orders.view')
                                            )}
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                )}
                <div className="text-sm text-gray-400 p-4">
                    {t('orders.showing', { start: 1, end: filteredShipments.length, total: filteredShipments.length })}
                </div>
            </div>

            {showModal2 && selectedShipment && (
                <div className="fixed inset-0 bg-black bg-opacity-70 z-50 flex items-center justify-center p-4 backdrop-blur-sm">
                    <div
                        className="rounded-3xl shadow-2xl text-white p-0 relative w-full max-w-4xl max-h-[92vh] overflow-hidden flex flex-col"
                        style={{
                            background: "radial-gradient(100% 100% at 50% 0%, #1D2461 0%, #080625 100%)",
                            border: "1px solid rgba(111, 26, 255, 0.2)"
                        }}
                    >
                        {/* Header */}
                        <div className="flex items-center justify-between p-6 border-b border-[#1E2A60] bg-[#10194E]/50">
                            <div>
                                <h2 className="text-2xl font-bold tracking-tight text-white flex items-center gap-3">
                                    {t('pod.detailedContainerView')}
                                    <span className={`text-xs px-3 py-1 rounded-full ${selectedShipment.status === 'Completed' ? 'bg-green-500/20 text-green-400 border border-green-500/50' : 'bg-yellow-500/20 text-yellow-400 border border-yellow-500/50'}`}>
                                        {selectedShipment.status || 'Pending'}
                                    </span>
                                </h2>
                                <p className="text-sm text-gray-400 mt-1">ID: <span className="text-cyan-400 font-mono">{selectedShipment.containerNumber || selectedShipment.Id || selectedShipment._id}</span></p>
                            </div>
                            <button
                                onClick={() => setShowModal2(false)}
                                className="w-10 h-10 rounded-full bg-[#1E2A60] flex items-center justify-center text-2xl font-light hover:bg-[#2A3AA5] transition-colors"
                            >
                                ×
                            </button>
                        </div>

                        {/* Content Area */}
                        <div className="flex-1 overflow-y-auto p-6 sm:p-8 space-y-8 hide-scrollbar">
                            
                            {/* Section 1: Logistics & Route */}
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                <div className="bg-[#10194E]/40 p-5 rounded-2xl border border-[#1E2A60] space-y-4">
                                    <h3 className="text-xs uppercase tracking-widest text-cyan-400 font-bold border-b border-[#1E2A60] pb-2">Logistics Overview</h3>
                                    <div className="space-y-4">
                                        <div className="flex items-start gap-3">
                                            <div className="w-8 h-8 rounded-full bg-blue-500/20 flex items-center justify-center text-blue-400 shrink-0 mt-1">📍</div>
                                            <div>
                                                <p className="text-[10px] uppercase text-gray-500 font-bold">Origin</p>
                                                <p className="text-sm text-gray-200">{selectedShipment.origin || selectedShipment.pickupAddress || selectedShipment.shipmentId?.origin || 'N/A'}</p>
                                            </div>
                                        </div>
                                        <div className="flex items-start gap-3">
                                            <div className="w-8 h-8 rounded-full bg-green-500/20 flex items-center justify-center text-green-400 shrink-0 mt-1">🏁</div>
                                            <div>
                                                <p className="text-[10px] uppercase text-gray-500 font-bold">Destination</p>
                                                <p className="text-sm text-gray-200">{selectedShipment.destination || selectedShipment.deliveryAddress || selectedShipment.shipmentId?.destination || 'N/A'}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="bg-[#10194E]/40 p-5 rounded-2xl border border-[#1E2A60] space-y-4">
                                    <h3 className="text-xs uppercase tracking-widest text-cyan-400 font-bold border-b border-[#1E2A60] pb-2">Driver & Vehicle</h3>
                                    <div className="grid grid-cols-2 gap-4">
                                        <div>
                                            <p className="text-[10px] uppercase text-gray-500 font-bold">Driver Name</p>
                                            <p className="text-sm text-white font-semibold">{selectedShipment.podDriverName || selectedShipment.assignedDriverId?.fullName || selectedShipment.acceptedId?.fullName || selectedShipment.userId?.fullName || 'N/A'}</p>
                                        </div>
                                        <div>
                                            <p className="text-[10px] uppercase text-gray-500 font-bold">Vehicle #</p>
                                            <p className="text-sm text-white font-semibold">{selectedShipment.vehicleNumber || selectedShipment.truckSize || 'N/A'}</p>
                                        </div>
                                        <div>
                                            <p className="text-[10px] uppercase text-gray-500 font-bold">Booking #</p>
                                            <p className="text-sm text-white font-semibold">{selectedShipment.bookingNumber || selectedShipment.Id || 'N/A'}</p>
                                        </div>
                                        <div>
                                            <p className="text-[10px] uppercase text-gray-500 font-bold">Contact #</p>
                                            <p className="text-sm text-white font-semibold">{selectedShipment.driverContactNumber || selectedShipment.assignedDriverId?.mobileNumber || selectedShipment.acceptedId?.mobileNumber || 'N/A'}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Section 2: Handling Details */}
                            <div className="bg-[#10194E]/40 p-6 rounded-2xl border border-[#1E2A60]">
                                <h3 className="text-xs uppercase tracking-widest text-cyan-400 font-bold border-b border-[#1E2A60] pb-3 mb-5">Handling & Shipment Details</h3>
                                <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
                                    <div className="p-3 bg-[#080625]/50 rounded-xl border border-white/5 text-center">
                                        <p className="text-[10px] uppercase text-gray-500 font-bold mb-1">Seal Number</p>
                                        <p className="text-lg font-bold text-white leading-none">{selectedShipment.cntSteal || 'N/A'}</p>
                                    </div>
                                    <div className="p-3 bg-[#080625]/50 rounded-xl border border-white/5 text-center">
                                        <p className="text-[10px] uppercase text-gray-500 font-bold mb-1">Pieces Received</p>
                                        <p className="text-lg font-bold text-white leading-none">{selectedShipment.noOfPiecesReceived || selectedShipment.pieces || '0'}</p>
                                    </div>
                                    <div className="p-3 bg-[#080625]/50 rounded-xl border border-white/5 text-center">
                                        <p className="text-[10px] uppercase text-gray-500 font-bold mb-1">Weight</p>
                                        <p className="text-lg font-bold text-white leading-none">{selectedShipment.weightInTons || selectedShipment.weight || selectedShipment.shipmentId?.weight || '0'}</p>
                                    </div>
                                    <div className="p-3 bg-[#080625]/50 rounded-xl border border-white/5 text-center">
                                        <p className="text-[10px] uppercase text-gray-500 font-bold mb-1">Pallets/Boxes</p>
                                        <p className="text-lg font-bold text-white leading-none">{selectedShipment.noOfPallets || selectedShipment.pallets || selectedShipment.boxes || '0'}</p>
                                    </div>
                                </div>
                                <div className="mt-6 grid grid-cols-1 md:grid-cols-2 gap-4">
                                    <div className="flex justify-between items-center py-2 border-b border-white/5">
                                        <span className="text-xs text-gray-400">Receiving Date</span>
                                        <span className="text-sm font-semibold">{(selectedShipment.receivingDate || selectedShipment.podDeliveredAt) ? format(new Date(selectedShipment.receivingDate || selectedShipment.podDeliveredAt), 'PPP') : 'N/A'}</span>
                                    </div>
                                    <div className="flex justify-between items-center py-2 border-b border-white/5">
                                        <span className="text-xs text-gray-400">Payment Status</span>
                                        <span className="text-sm font-semibold text-green-400">{selectedShipment.paymentStatus || 'Pending'}</span>
                                    </div>
                                </div>
                            </div>

                            {/* Section 3: Photo Proofs */}
                            <div className="space-y-4">
                                <h3 className="text-xs uppercase tracking-widest text-cyan-400 font-bold flex items-center gap-2">
                                    <span className="w-2 h-2 rounded-full bg-cyan-400"></span>
                                    Visual Proof of Delivery
                                </h3>
                                
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                    {/* Container Images */}
                                    <div className="bg-[#080625]/30 p-4 rounded-2xl border border-white/5">
                                        <p className="text-xs text-gray-400 font-semibold mb-3">Container/Load Photos</p>
                                        <div className="grid grid-cols-3 gap-2">
                                            {selectedShipment.podContainerImage?.length > 0 ? (
                                                selectedShipment.podContainerImage.map((url, i) => (
                                                    <img key={i} src={url} className="w-full h-20 object-cover rounded-lg border border-white/10 hover:scale-105 transition-transform" />
                                                ))
                                            ) : selectedShipment.podImage ? (
                                                <img src={selectedShipment.podImage} className="w-full h-20 object-cover rounded-lg border border-white/10 hover:scale-105 transition-transform" />
                                            ) : (
                                                <p className="col-span-3 text-xs text-gray-600 italic py-4 text-center">No photos uploaded</p>
                                            )}
                                        </div>
                                    </div>

                                    {/* Cargo Images */}
                                    <div className="bg-[#080625]/30 p-4 rounded-2xl border border-white/5">
                                        <p className="text-xs text-gray-400 font-semibold mb-3">Cargo Photos</p>
                                        <div className="grid grid-cols-3 gap-2">
                                            {selectedShipment.podCargo?.length > 0 ? selectedShipment.podCargo.map((url, i) => (
                                                <img key={i} src={url} className="w-full h-20 object-cover rounded-lg border border-white/10 hover:scale-105 transition-transform" />
                                            )) : <p className="col-span-3 text-xs text-gray-600 italic py-4 text-center">No photos uploaded</p>}
                                        </div>
                                    </div>

                                    {/* Delivery Site */}
                                    <div className="bg-[#080625]/30 p-4 rounded-2xl border border-white/5">
                                        <p className="text-xs text-gray-400 font-semibold mb-3">Delivery Site Proof</p>
                                        <div className="grid grid-cols-3 gap-2">
                                            {selectedShipment.podDeliverySite?.length > 0 ? selectedShipment.podDeliverySite.map((url, i) => (
                                                <img key={i} src={url} className="w-full h-20 object-cover rounded-lg border border-white/10 hover:scale-105 transition-transform" />
                                            )) : <p className="col-span-3 text-xs text-gray-600 italic py-4 text-center">No photos uploaded</p>}
                                        </div>
                                    </div>

                                    {/* Documents */}
                                    <div className="bg-[#080625]/30 p-4 rounded-2xl border border-white/5">
                                        <p className="text-xs text-gray-400 font-semibold mb-3">Official Documents</p>
                                        <div className="grid grid-cols-3 gap-2">
                                            {selectedShipment.podDocuments?.length > 0 ? selectedShipment.podDocuments.map((url, i) => (
                                                <img key={i} src={url} className="w-full h-20 object-cover rounded-lg border border-white/10 hover:scale-105 transition-transform" />
                                            )) : <p className="col-span-3 text-xs text-gray-600 italic py-4 text-center">No documents uploaded</p>}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Section 4: Signatures */}
                            <div className="pt-4 border-t border-[#1E2A60] flex flex-col md:flex-row gap-8">
                                <div className="flex-1 space-y-4">
                                    <p className="text-xs uppercase tracking-widest text-gray-500 font-bold flex items-center gap-2">
                                        <span className="w-1 h-3 bg-cyan-400 rounded-full"></span>
                                        Driver Acknowledgment
                                    </p>
                                    <div className="bg-white/5 p-4 rounded-2xl border border-white/5 flex items-center justify-center min-h-[120px]">
                                        {selectedShipment.podDriverSign ? (
                                            <img src={selectedShipment.podDriverSign} className="max-h-24 object-contain invert brightness-200" />
                                        ) : selectedShipment.podImage ? (
                                            <p className="text-xs text-gray-400 italic">Signature not required for this load type, see POD photo</p>
                                        ) : (
                                            <p className="text-xs text-gray-600 italic">No signature recorded</p>
                                        )}
                                    </div>
                                    <p className="text-center text-sm font-semibold">{selectedShipment.podDriverName || selectedShipment.assignedDriverId?.fullName || 'Driver Signature'}</p>
                                </div>

                                <div className="flex-1 space-y-4">
                                    <p className="text-xs uppercase tracking-widest text-gray-500 font-bold flex items-center gap-2">
                                        <span className="w-1 h-3 bg-green-400 rounded-full"></span>
                                        Customer Receipt
                                    </p>
                                    <div className="bg-white/5 p-4 rounded-2xl border border-white/5 flex items-center justify-center min-h-[120px]">
                                        {(selectedShipment.podCustomerSign || selectedShipment.recipientSignature) ? (
                                            <img src={selectedShipment.podCustomerSign || selectedShipment.recipientSignature} className="max-h-24 object-contain invert brightness-200" />
                                        ) : (
                                            <p className="text-xs text-gray-600 italic">No signature recorded</p>
                                        )}
                                    </div>
                                    <p className="text-center text-sm font-semibold">{selectedShipment.recipientName || 'Consignee Signature'}</p>
                                </div>
                            </div>

                        </div>

                        {/* Footer Actions */}
                        <div className="p-6 border-t border-[#1E2A60] bg-[#10194E]/50 flex gap-4">
                            <button
                                onClick={openSuccessModal}
                                className="flex-1 py-4 rounded-2xl bg-gradient-to-r from-[#6E00FF] to-[#A627FF] text-white font-bold hover:shadow-[0_0_20px_rgba(110,0,255,0.4)] transition-all flex items-center justify-center gap-2"
                            >
                                📥 {t('pod.downloadReport')}
                            </button>
                            <button
                                onClick={() => setShowModal2(false)}
                                className="px-8 py-4 rounded-2xl bg-[#1E2A60] text-white font-bold hover:bg-[#2A3AA5] transition-colors"
                            >
                                {t('invoice.close')}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {showRequestModal && (
                <div className="fixed inset-0 bg-black bg-opacity-50 z-20 flex items-center justify-center p-4">
                    <div
                        className="rounded-xl shadow-xl text-white p-4 sm:p-6 relative w-full max-w-md max-h-[90vh] overflow-y-auto hide-scrollbar"
                        style={{
                            background: "radial-gradient(50% 49.39% at 50% 50%, #1D2461 0%, #080625 100%)",
                        }}
                    >
                        <button
                            onClick={() => setRequestModal(false)}
                            className="absolute top-2 right-4 text-2xl font-bold hover:text-gray-300"
                            aria-label={t('alt.closeRequestModal')}
                        >
                            ×
                        </button>
                        <h2 className="text-lg sm:text-xl font-bold mb-4">{t('pod.requestReason')}</h2>
                        <form className="space-y-4">
                            <div className="relative w-full">
                                <label className="text-sm block mb-1 text-white">{t('pod.selectReason')}</label>
                                <div
                                    className="border rounded px-3 py-2 bg-white text-black flex justify-between items-center cursor-pointer"
                                    onClick={() => setIsOpen(!isOpen)}
                                    aria-expanded={isOpen}
                                    aria-label={t('pod.selectReason')}
                                >
                                    <span>{selected || t('pod.selectReasonPlaceholder')}</span>
                                    <FiChevronDown className={`transition-transform ${isOpen ? "rotate-180" : ""}`} />
                                </div>
                                {isOpen && (
                                    <div className="absolute z-10 mt-1 w-full bg-white shadow-lg rounded p-2">
                                        {["Incomplete Docs", "Blurry image", "Other"].map((item) => (
                                            <div
                                                key={item}
                                                className="cursor-pointer text-blue-600 px-2 py-1 hover:bg-gray-100 rounded text-sm"
                                                onClick={() => handleSelect(item)}
                                            >
                                                {t(`pod.reasons.${item.toLowerCase().replace(' ', '_')}`, { defaultValue: item })}
                                            </div>
                                        ))}
                                        <div className="mt-2 flex items-center gap-2 border rounded px-2 py-1">
                                            <input
                                                type="text"
                                                placeholder={t('pod.customReasonPlaceholder')}
                                                className="flex-1 text-sm outline-none text-black"
                                                value={customReason}
                                                onChange={(e) => setCustomReason(e.target.value)}
                                                aria-label={t('pod.customReason')}
                                            />
                                            <button className="text-black" aria-label={t('pod.submitCustomReason')}>
                                                ➤
                                            </button>
                                        </div>
                                    </div>
                                )}
                            </div>
                            <button
                                type="submit"
                                onClick={() => setRequestModal(false)}
                                className="w-full bg-[#FF4F4F] text-white py-2 rounded-md font-semibold hover:opacity-90"
                                aria-label={t('pod.submitRequest')}
                            >
                                {t('pod.submitRequest')}
                            </button>
                            <button
                                type="button"
                                onClick={() => setRequestModal(false)}
                                className="w-full text-white py-2 rounded-md font-semibold hover:underline"
                                aria-label={t('pod.cancelRequest')}
                            >
                                {t('pod.cancelRequest')}
                            </button>
                        </form>
                    </div>
                </div>
            )}

            {isSuccessModalOpen && (
                <div className="fixed inset-0 bg-black bg-opacity-50 z-20 flex items-center justify-center p-4">
                    <div className="bg-[#0F0D2E] p-4 sm:p-8 rounded-2xl w-full max-w-md text-center" style={{ backdropFilter: 'blur(42.7px)' }}>
                        <h2 style={{ fontFamily: "Poppins" }} className="text-lg sm:text-[30px] font-bold text-white leading-tight">
                            {t('pod.podDownloaded')} <span className="text-[24px] sm:text-[45px] text-[#6F1AFF]">{t('pod.successfully')}</span>
                        </h2>
                        <p className="text-xs sm:text-sm text-gray-400 mb-6 mt-1">
                            {t('pod.downloadSuccessMessage')}
                        </p>
                        <div className="flex justify-center mb-6">
                            <img src={check} alt={t('alt.checkmark')} className="w-[150px] sm:w-[197px] h-auto" />
                        </div>
                        <button
                            onClick={() => setIsSuccessModalOpen(false)}
                            className="w-full max-w-[300px] py-2 sm:py-3 bg-[#6F1AFF] text-white rounded-xl hover:opacity-90 transition font-medium"
                            aria-label={t('success.confirm')}
                        >
                            {t('success.confirm')}
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default ProofOfDelivery;